<template>
  <PartsChromeLink :to="button.to" class="welcome-support_btn" :class="variantClass">
    <span v-if="button.icon" class="welcome-support_btn_icon">
      <img :src="button.icon" alt="" />
    </span>
    {{ button.label }}
    <span v-if="!button.icon" class="welcome-support_btn_arrow" aria-hidden="true"></span>
  </PartsChromeLink>
</template>

<script setup lang="ts">
/**
 * 「初めての方へ」のポイント内のボタン（支給デザインの `welcome-support_btn`）。
 *
 * 支給は2種類あり、**アイコンと矢印は排他**。
 * - `_green`（1件）… 緑地。文字の前に会員登録アイコンを置く。矢印は無い
 * - `_outline`（3件）… 白地に緑の枠。文字の後ろに矢印を置く。アイコンは無い
 *
 * `parts/action-btn.vue` とは別のクラス体系なので流用しない
 * （`renewal/style.css` の `.welcome-support_btn` 系）。
 */
import type { WelcomeSupportItem } from '@/types/domains/WelcomeType';

type Props = {
  button: WelcomeSupportItem['button'];
};

const props = defineProps<Props>();

const variantClass = computed<string>(() => `welcome-support_btn_${props.button.variant}`);
</script>
